import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PaymentMethod } from '../../../../enums/payment-method.enum';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs';
import { InvoicesService } from '../../../core/services/invoice/invoices.service';
import { ToastService } from '../../../core/services/toast.service';
import { Patient, Case } from '../../../core/models/invoice/paitent.model';
import { InvoiceModalComponent } from '../../components/modals/invoice-modal/invoice-modal.component';
import { RecordItem } from '../../../core/models/invoice/record-items.model';
declare var bootstrap: any;

@Component({
  selector: 'app-invoice-actions',
  standalone: true,
  imports: [CommonModule, TranslateModule, InvoiceModalComponent],
  templateUrl: './invoice-actions.component.html',
  styleUrl: './invoice-actions.component.scss',
})
export class InvoiceActionsComponent {
  @Input() row: RecordItem;
  @Input() data: any[] = [];

  @Output() invoiceActionClicked = new EventEmitter<{
    event: Event;
    row: RecordItem;
  }>();

  @ViewChild(InvoiceModalComponent) invoiceModal: InvoiceModalComponent;
  isLoad: boolean = false;
  isLoadedInvoice: boolean = false;
  paymentMethod = PaymentMethod;
  paymentMethodList: number[] = [PaymentMethod.PIN, PaymentMethod.INVOICE];
  patientRecordId: string = '';
  pidNo: string = '';
  patientReport: string = '';
  invoiceReportGenerated: boolean = false;
  intervalId: any = null;

  constructor(
    private invoicesService: InvoicesService,
    private translate: TranslateService,
    private toastService: ToastService
  ) {
    const userLang = localStorage.getItem('selectedLanguage') || 'en';
    this.translate.use(userLang);
  }

  togglePayService(
    patientRecordId: string,
    paymentMethod: PaymentMethod,
    status: 'selected' | 'not-selected'
  ) {
    let resultPaymentMethod =
      status === 'selected' ? PaymentMethod.NONE : paymentMethod;

    this.updatePaymentMethod(patientRecordId, resultPaymentMethod);

    this.data.forEach((item: RecordItem) => {
      if (item.patientRecordId === patientRecordId) {
        item.paymentMethod = resultPaymentMethod;
      }
    });
  }

  updatePaymentMethod(patientRecordId: string, paymentMethod: PaymentMethod) {
    const form = {
      patientRecordId,
      paymentMethod,
    };
    this.isLoad = true;
    this.invoicesService.updatePaymentMethod(patientRecordId, form).subscribe(e => {
      this.invoicesService
        .createInvoiceReport(patientRecordId).subscribe(res => {
          this.isLoad = true;
          setTimeout(() => {
            this.isLoad = false;
            this.isLoadedInvoice = true;
          }, 5000);
        })
    });
  }

  handleInvoice(row: RecordItem) {
    this.resetReport();
    this.patientRecordId = row.patientRecordId;
    this.patientRecordId = row.patientRecordId;
    this.pidNo = row.pidNo;
    this.invoiceActionClicked.emit({ event, row });
    this.setInvoiceModalId(row);
  }

  setInvoiceModalId(row: RecordItem) {
    setTimeout(() => {
      const modalId = 'invoiceModal-' + row.patientRecordId;
      const modalElement = document.getElementById(modalId);
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
        this.getInvoiceReport(row);
      } else {
        console.error('Modal element with ID', modalId, 'not found');
      }
    }, 100);
  }

  checkInvoiceReportRecursive(row: RecordItem): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      const { patientRecordId, fileName } = row;
      this.invoicesService
        .checkInvoiceReport(patientRecordId, fileName)
        .subscribe({
          next: (res) => {
            // debugger

            if (res) {
              this.isLoadedInvoice = false;
              this.invoicesService.invoiceReport(patientRecordId, fileName).subscribe(res2 => {
                this.invoiceReportGenerated = true;
                this.displayPdf(res2.bytes);
                this.patientReport = res2.bytes;
              })
              observer.next(true);
              observer.complete();
            } else {
              setTimeout(() => {
                this.checkInvoiceReportRecursive(row).subscribe();
              }, 2000);
              // observer.next(false);
            }
          },
        });
    });
  }

  async getInvoiceReport(row: RecordItem) {
    const { patientRecordId, fileName } = row;
    return this.invoicesService
      .createInvoiceReport(patientRecordId).subscribe(e => {
        this.checkInvoiceReportRecursive(row).subscribe(res => {
        });
      });
  }

  checkInvoiceReportExists(patientRecordId: string) {
    return this.data.find((item) => item.patientRecordId === patientRecordId)
      .invoiceGenerated;
  }

  downloadInvoice() {
    if (this.invoiceReportGenerated) {
      const base64Pdf = this.patientReport;
      const byteCharacters = atob(base64Pdf);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style.display = 'none';
      a.href = url;
      const date = new Date();
      const formattedDate = date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
      const invoiceItem = this.data.find(
        (item: any) => item.patientRecordId === this.patientRecordId
      );

      a.download = `DERM${invoiceItem.pidNo}_${formattedDate}_invoice.pdf`;
      a.click();

      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
  }

  sendInvoice() {
    this.invoicesService.sendInvoice(this.patientRecordId).subscribe({
      next: () => {
        this.toastService.showToast(
          this.translate.instant('invoiceSentSuccessfully'),
          'success'
        );
      },
    });
  }

  resetReport() {
    this.invoiceReportGenerated = false;
    const invoiceReportContent = document.getElementById(
      'invoiceReport-' + this.patientRecordId
    );
    if (invoiceReportContent) {
      invoiceReportContent.innerHTML = '';
    }
  }

  handleCloseModal() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  displayPdf(base64Pdf: string) {
    const byteCharacters = atob(base64Pdf);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);
    const iframe = document.createElement('iframe');
    iframe.src = blobUrl;
    iframe.width = '100%';
    iframe.height = '600px';
    iframe.style.border = 'none';

    let content: HTMLElement | null = null;
    content = document.getElementById('invoiceReport-' + this.patientRecordId);

    if (content) {
      content.innerHTML = '';
      content.appendChild(iframe);
      iframe.oncancel = () => {
        URL.revokeObjectURL(blobUrl);
      };
    }
  }

  paidStatus(patientRecordId: string) {
    const patientRecord = this.data.find(
      (item: Patient) => item.patientRecordId === patientRecordId
    );

    const paid = patientRecord?.cases.every(
      (item: Case) => item.paymentMethod !== PaymentMethod.NONE
    );
    const open = patientRecord?.cases.every(
      (item: Case) => item.paymentMethod === PaymentMethod.NONE
    );
    const partiallyPaid = patientRecord?.cases.some(
      (item: Case) => item.paymentMethod === PaymentMethod.NONE
    );

    return paid
      ? 'paid'
      : open
        ? 'open'
        : partiallyPaid
          ? 'partiallyPaid'
          : 'notPaid';
  }
}
